import Select from './Select'
import Text from './Text'
import Password from './Password'
import Code from './Code'

const Input = {
  Select,
  Text,
  Password,
  Code
}

export default Input